export interface UserProfileAlbumParams {
  userId: string
}

export const userProfileAlbumPartialPath = '/albums'
export const userProfileAlbumPath = `${userProfileAlbumPartialPath}/:userId(\\d+)`
